<template>
  <div id="app">
    <router-view></router-view>
    <!-- <home></home> -->
  </div>
</template>

<script>
// import home from '@/components/home.vue'

export default {
  components: { 
    // home
  },
  mounted() {
    // console.log(process.env)
  }
}
</script>

<style scoped>
#app {
  overflow-y: scroll;
}
</style>
